import { Hub, ConsoleLogger } from 'aws-amplify/utils'

Hub.listen('auth', data => {
  const logger = new ConsoleLogger('auth hub handler')
  switch (data.payload.event) {
    case 'signedIn':
      logger.info('user signed in')
      break
    case 'signUp':
      logger.info('user signed up')
      break
    case 'signedOut':
      logger.info('user signed out')
      break
    case 'signIn_failure':
      logger.warn('user sign in failed')
      break
    case 'configured':
      logger.info('the Auth module is configured')
      break
    default:
      logger.warn('unknown event ' + data.payload.event)
      break
  }
})
